export enum ConfigurableStatuses {
  ACTIVE= 'active',
  PASSIVE = 'passive'
}

export enum AllowedProviders {
  MOCK_CLOUD = 'mock-cloud',
  GCP = 'gcp'
}

export enum AllowedCurrencies {
  EUR = 'EUR',
  USD = 'USD'
}

export enum FeatureTypes {
  DOMAIN = 'domain',
  FEATURE = 'feature',
  CAPABILITY = 'capability',
  RETENTION = 'retention',
  BACKUP = 'backup'
}

export enum FeatureStatus {
  ACTIVE = 'active',
  PASSIVE = 'passive',
}
